import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { DialogContent, DialogTitle, Modal } from 'base-ui'

import {
  CROSS_SELL_ADD_TO_CART_BOTTOM,
  CROSS_SELL_ADD_TO_CART_CENTER,
  CROSS_SELL_ADD_TO_CART_TOP,
} from '../../cross-sell'
import { DrawerTransition } from '../../drawer-transition'
import { useSearchParamDependentOpenableControls } from '../../generic-hooks'
import { useCartIntermediateContext } from '../context/CartIntermediateContext'

import { CartIntermediateCrossSellSliderWidget } from './CartIntermediateCrossSellSliderWidget'
import { CartIntermediateMessages } from './CartIntermediateMessages/CartIntermediateMessages'
import { CartIntermediateProductWithButtonsSection } from './CartIntermediateProductWithButtonsSection/CartIntermediateProductWithButtonsSection'

type CartIntermediateDrawerProps = {
  drawerId: string
}

export const CartIntermediateDrawer: FC<CartIntermediateDrawerProps> = ({
  drawerId,
}) => {
  const { handleClose, isOpen } = useSearchParamDependentOpenableControls({
    paramName: drawerId,
  })

  const { isAddProductToCartSuccessful } = useCartIntermediateContext()

  return (
    <Modal
      className="flex flex-col items-end justify-end rounded-l-2xl"
      closeAfterTransition
      data-qa-id={drawerId}
      onClose={handleClose}
      open={isOpen}
    >
      <DrawerTransition
        className="mt-[120px] flex h-dvh w-full flex-col overflow-y-auto rounded-t-2xl bg-light-primary-medium outline-none tablet:mt-0 tablet:max-w-screen-tablet tablet:rounded-l-2xl tablet:rounded-tr-none"
        in={isOpen}
      >
        <DialogTitle className="bg-light-primary-medium" onClose={handleClose}>
          <FormattedMessage id="cartIntermediate.drawer.title" />
        </DialogTitle>
        <DialogContent>
          <CartIntermediateMessages
            isProductSuccessfullyAdded={isAddProductToCartSuccessful}
          />
          <CartIntermediateProductWithButtonsSection
            handleClose={handleClose}
          />
          <CartIntermediateCrossSellSliderWidget
            itemsPerPage={4}
            type={CROSS_SELL_ADD_TO_CART_TOP}
          />
          <CartIntermediateCrossSellSliderWidget
            itemsPerPage={4}
            type={CROSS_SELL_ADD_TO_CART_CENTER}
          />
          <CartIntermediateCrossSellSliderWidget
            itemsPerPage={4}
            type={CROSS_SELL_ADD_TO_CART_BOTTOM}
          />
        </DialogContent>
      </DrawerTransition>
    </Modal>
  )
}
